import apiClient from './index';

export default {
    getTasks(params) {
        return apiClient.get('/tasks', { params });
    },
    getTaskDetail(taskId) {
        return apiClient.get(`/tasks/${taskId}`);
    },
    createTask(data) {
        return apiClient.post('/task', data);
    },
    addTask(data) {
        return apiClient.post('/task/add', data);
    },
    updateTask(data) {
        return apiClient.post(`/task/edit`, data);
    },
    deleteTask(taskId) {
        return apiClient.delete(`/tasks/${taskId}`);
    },
    submitTask() {
        console.warn('submitTask method is deprecated, use completeTask instead');
        return Promise.resolve();
    },
    getTaskSubmissions(params) {
        return apiClient.get('/tasks/submissions', { params });
    },
    reviewTask(userTaskId, data) {
        return apiClient.post(`/tasks/submissions/${userTaskId}/review`, data);
    },
    uploadFile(data) {
        return apiClient.post('/upload', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    deleteFile(filename) {
        return apiClient.delete(`/upload/${filename}`);
    },
    getListByPartId(part) {
        return apiClient.get(`/task/listByPartId?part=${part}`);
    },
    completeTask(data) {
        return apiClient.post('/usertask/complete', data);
    },
    getTaskInfo(taskId) {
        return apiClient.get(`/task/info?taskId=${taskId}`);
    },
    getSettings() {
        return apiClient.get('/task/settings');
    },
    getAllUserTaskStats(username = '') {
        return apiClient.get('/usertask/all', { params: { username } });
    }
}; 